import { Link } from 'react-router';
import { cn } from '@/libs/utils/cn';

interface LogoProps {
  className?: string;
}

export function Logo(props: LogoProps) {
  const { className } = props;

  return (
    // One weight, tight tracking: a wordmark, not two words in two styles.
    <Link
      to="/"
      aria-label="SpotOn"
      className={cn('text-[22px] font-semibold leading-none tracking-[-0.03em]', className)}
    >
      <span className="text-primary-700">Spot</span>
      <span className="text-brand">On</span>
    </Link>
  );
}
